<template>
  <div class="report-card">
    <div class="report-card__top">
      <!-- eslint-disable vue/no-v-html -->
      <div class="report-card__title" v-html="report.name" />
      <!-- eslint-enable vue/no-v-html -->

      <div class="report-card__actions">
        <div class="edit-card" @click="viewItem(report.id)">View</div>
        <div class="dell-card" @click="deleteItem">Delete</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserReportListCard",
  components: {
    // Tag: () => import("../elements/Tag.vue"),
  },
  props: {
    report: {
      type: Object,
      default: null,
    },
    redirectUrl: {
      type: String,
      default: "reportbuilder",
    }
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    viewItem(id) {
      this.$router.push({ path: `/${this.redirectUrl}`, query: { reportId: id } });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    deleteItem() {
      this.$store.commit("Dialog/setData", {
        label: "confirmDeleteDialogData",
        data: { draw: this.customFilterData, save: this.saveFilterData },
      });
      this.$store.commit("Dialog/setData", {
        label: "confirmDeleteDialog",
        data: { visible: true, id: this.report.id },
      });
      this.$emit("updateUserReports");
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.report-card {
  margin-bottom: 5rem;
  position: relative;

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px dashed $border;
    margin-bottom: 1rem;
  }

  &__actions {
    display: flex;
    align-items: center;
    font-size: 1.2rem;

    .edit-card {
      cursor: pointer;
    }

    .dell-card {
      color: $red;
      margin: 0 2rem;
      cursor: pointer;
    }
  }

  &__bottom {
    display: flex;
    align-items: center;

    .cancel {
      margin-left: 3rem;
      flex-shrink: 0;
      font-size: 1.2rem;
      cursor: pointer;
    }
  }

  &__edit-name {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;

    input {
      border: 1px solid #c6d5e0;
      width: 100%;
      display: block;
      padding: 0 8rem 0 2rem;
      height: 4rem;
    }

    .save {
      position: absolute;
      right: 1rem;
      background: $red;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $white;
      font-weight: 700;
      font-size: 1.4rem;
      width: 6rem;
      height: 3rem;
    }
  }

  .article__tags {
    border-bottom: none;

    &-more {
      margin-left: 1rem;
      font-weight: 600;
    }
  }
}
</style>
